import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { SystemConfigValue } from 'src/app/admin/system-configuration/shared/models/system-config-value';
import { getSystemConfigurations } from 'src/app/state';
import { State } from './state';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lobby-central-views',
  templateUrl: './lobby-central-views.component.html',
  styleUrls: ['./lobby-central-views.component.scss']
})
export class LobbyCentralViewsComponent implements OnInit, OnDestroy {
  public staffColumnText?: string;
  public views: any;
  public radioSel: any;
  public radioSelected: any;
  public radioSelectedString: any;
  public viewsTranslation: any;
  
  subscriptions = new Subscription();
  active: any
  constructor(private store: Store<State>, private translationLoaderFacade: TranslationLoaderFacade, private translateService: TranslateService ) {
    
   }

  ngOnInit() {
    this.subscriptions.add(
      this.store.select(getSystemConfigurations).subscribe(
        (configurations) => {
          const lobbyConfigurations = configurations.filter(c => c.configurationGroup === 'LobbySettings');
          if (lobbyConfigurations.length > 0) {
            this.staffColumnText = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'StaffStatusDisplayText'))
            const defaultCentralLobbyTab = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'DefaultLobbyTab'));
            this.translateService.get(['_Lobby_Central_Lobby_View_Ts_Text_', '_Lobby_Central_Ts_Text_', '_Lobby_Status_View_Ts_Text_', '_Lobby_Central_Location_View_Ts_Text_']).subscribe((translations) => {
              this.viewsTranslation = [
                {
                  id: 1,
                  value: translations['_Lobby_Central_Lobby_View_Ts_Text_']
                },
                {
                  id: 2,
                  value: translations['_Lobby_Central_Ts_Text_'] + ' ' + this.staffColumnText + ' ' + translations['_Lobby_Status_View_Ts_Text_']
                },
                {
                  id: 3,
                  value: translations['_Lobby_Central_Location_View_Ts_Text_']
                }
              ];
            });
            this.views = [
              {
                id: 1,
                value: this.viewsTranslation[0].value
              },
              {
                id: 2,
                value: this.viewsTranslation[1].value
              },
              {
                id: 3,
                value: this.viewsTranslation[2].value
              }
            ];

            switch (defaultCentralLobbyTab) {
              case '3':
                this.radioSelectedString = this.views[0];
                this.radioSelected =  this.views[0].value;
                break;
              case '4':
                this.radioSelectedString = this.views[1];
                this.radioSelected =  this.views[1].value;
                break;
              case '5':
                this.radioSelectedString = this.views[2];
                this.radioSelected =  this.views[2].value;
                break;
              default:
                this.radioSelectedString = this.views[0];
                this.radioSelected =  this.views[0].value;
                break;
            }
          }
        }
      )
    );  
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /**
   * Fetches the selected radio button
   */
  public getSelecteditem() {
    console.log(this.radioSelected);
    
    this.radioSel = this.views.find((Item: any) => Item.value === this.radioSelected);
    this.radioSelectedString = this.radioSel;
  }

  /**
   *
   * Triggers when radio button change
   */
  public onItemChange(item: any) {
    this.getSelecteditem();
  }

  private readCastedValue(systemConfigValue?: SystemConfigValue): any {
    if (systemConfigValue) {
      switch (systemConfigValue.dataType) {
          case 'int':
              return parseInt(systemConfigValue.value, undefined);
          case 'bool':
              return (systemConfigValue.value === '1');
          default:
              return systemConfigValue.value;
      }
      
    }
  }

}

